import { Typography } from '@mui/material'
import colors from 'styles/colors'
import BoxWithBackground from './container/BoxWithBackground'
import RowStack from './container/RowStack'
import { IconContainer } from './Icons'
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'

const NotificationBanner = ({
  icon = <CampaignOutlinedIcon />,
  notificationText,
  sx = {}
}) => {
  return (
    <BoxWithBackground
      sx={{
        width: '100%',
        minHeight: 48,
        px: 8,
        py: 4,
        borderRadius: 2.5,
        border: `1px solid ${colors.MutedTeal200}`,
        backgroundColor: colors.MutedTeal50,
        ...sx
      }}>
      <RowStack spacing={4} height='100%'>
        <IconContainer icon={icon} />
        <Typography fontWeight={500}>{notificationText}</Typography>
      </RowStack>
    </BoxWithBackground>
  )
}

export default NotificationBanner
